/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { FileSearchRecord } from '../models/FileSearchRecord';
import { Pagination } from '../models/Pagination';

export class FileExplorerResponse {
  'data': Array<FileSearchRecord>;
  'pagination': Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "data",
      "baseName": "data",
      "type": "Array<FileSearchRecord>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FileExplorerResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

